import type { DataFilePreview } from '../api/types.js';
import { useAsyncUpload } from './useAsyncUpload.js';
import { useAsyncValidation } from './useAsyncValidation.js';

export const useDataFileSockets = ({
  dataFileId,
  dataFilePreview,
}: {
  dataFileId: string;
  dataFilePreview: DataFilePreview;
}) => {
  useAsyncUpload({
    dataFileId,
  });

  useAsyncValidation({
    dataFileId,
    dataFilePreview,
  });
};
